import { getStore } from "trim-redux";
import { isAdmin, isSupplier } from "./Permissions";

export const isDesktopApp = () =>
  typeof window !== "undefined" && window.kolaydoyDesktop?.isDesktop === true;

export const getDesktopRedirectPath = () => {
  const isAuth = getStore("isAuth");
  if (!isAuth) {
    return "/login";
  }
  if (isAdmin() || isSupplier()) {
    return "/panel/dashboard";
  }
  return "/login";
};

const DESKTOP_ALLOWED_PREFIXES = [
  "/login",
  "/email-login",
  "/user-info",
  "/register",
  "/reset-password",
  "/panel",
];

export const isDesktopBlockedPath = (pathname) => {
  if (!pathname) {
    return false;
  }

  return !DESKTOP_ALLOWED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};
